module.exports = __webpack_public_path__ + "static/img/investor2.9f15bda8.png";